import React from 'react';
import { Loading, Sizes } from '@sede-enterprise/shell-ds-react-framework';

const  Loader = () => {
    return (
        <div style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'}}> 
            <Loading size={Sizes.Large} /> 
        </div>
    )
}
export default Loader;